import { useQuery } from '@tanstack/react-query';
import { Users } from 'lucide-react';
import { Link } from 'react-router-dom';
import { apiClient } from '@/lib/api-client';
import { cn } from '@/lib/utils';
import { CardShell, EmptyState } from './card-shell';

export function ClientsOverviewCard() {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['clients', 'stats', 'summary'],
    queryFn: () => apiClient.clientsStatsSummary(),
    staleTime: 1000 * 60,
  });

  if (isLoading) {
    return (
      <CardShell title="Clientes" icon={Users}>
        <div className="flex w-full flex-col items-start gap-2">
          <div className="h-10 w-24 animate-pulse rounded bg-[var(--surface-muted)]" />
          <div className="h-3 w-32 animate-pulse rounded bg-[var(--surface-muted)]" />
        </div>
      </CardShell>
    );
  }

  if (isError) {
    return (
      <CardShell title="Clientes" icon={Users}>
        <p className="text-xs text-[var(--fg-muted)]">
          Não foi possível carregar.
        </p>
      </CardShell>
    );
  }

  const total = data?.totalContacts ?? 0;

  if (total === 0) {
    return (
      <CardShell title="Clientes" icon={Users}>
        <EmptyState
          icon={Users}
          message="Nenhum cliente cadastrado ainda. Comece adicionando o primeiro."
          cta={{ label: '+ Novo cliente', href: '/escritorio/clientes/novo' }}
        />
      </CardShell>
    );
  }

  return (
    <CardShell title="Clientes" icon={Users}>
      <div className="flex w-full flex-col items-start gap-2">
        <span className="tabular-nums text-3xl font-semibold tracking-tight text-[var(--fg)]">
          {total}
        </span>
        <p className="text-[11px] text-[var(--fg-muted)]">
          Contatos cadastrados
        </p>
        <Link
          to="/escritorio/clientes"
          className={cn(
            'mt-1 inline-flex items-center gap-1 rounded-md px-3 py-1.5 text-xs font-medium transition',
            'border border-[var(--border)] text-[var(--fg)] hover:bg-[var(--surface-muted)]',
            'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--accent)]',
          )}
        >
          Ver todos
        </Link>
      </div>
    </CardShell>
  );
}
